import React, { useEffect, useState } from 'react';
import { CreateUserModal } from './CreateUserModal';
import { useAdminStore } from '../../../lib/store-admin';
import { supabase } from '../../../lib/supabase';
import { PastSessions } from '../../dashboard/PastSessions';

interface InstitutionUserListProps {
    institutionId: string;
    onBack: () => void;
    onViewReport: () => void;
}

export const InstitutionUserList: React.FC<InstitutionUserListProps> = ({ institutionId, onBack, onViewReport }) => {
    const [users, setUsers] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [selectedUserForReports, setSelectedUserForReports] = useState<string | null>(null); // State for selected user



    const fetchUsers = React.useCallback(async () => {
        setIsLoading(true);
        if (!supabase) {
            setIsLoading(false);
            return;
        }

        console.log('Fetching users for institution:', institutionId);

        try {
            const { data, error } = await supabase
                .from('profiles')
                .select('*')
                .eq('institution_id', institutionId)
                .order('created_at', { ascending: false });

            if (error) {
                console.error('Error fetching users:', error);
                throw error;
            }

            console.log('Fetched users:', data);
            if (data) setUsers(data);
        } catch (error) {
            console.error('Exception fetching users:', error);
        } finally {
            setIsLoading(false);
        }
    }, [institutionId]);

    useEffect(() => {
        fetchUsers();
    }, [fetchUsers]);

    const { deleteUser } = useAdminStore();

    const handleDeleteUser = async (userId: string, userName: string) => {
        if (window.confirm(`${userName} kullanıcısını silmek istediğinize emin misiniz? Bu işlem geri alınamaz.`)) {
            const result = await deleteUser(userId);
            if (result.success) {
                fetchUsers(); // Refresh list
            } else {
                alert('Silme işlemi başarısız: ' + result.error);
            }
        }
    };

    if (selectedUserForReports) {
        return (
            <div className="admin-reports-view">
                <button
                    onClick={() => setSelectedUserForReports(null)}
                    style={{ marginBottom: '20px', padding: '10px', cursor: 'pointer' }}
                >
                    &larr; Kullanıcı Listesine Dön
                </button>
                <PastSessions
                    onBack={() => setSelectedUserForReports(null)}
                    userId={selectedUserForReports}
                    onViewReport={onViewReport}
                />
            </div>
        );
    }



    return (
        <div className="institution-user-list">
            <div className="list-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <button onClick={onBack} style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                        <span className="material-symbols-outlined">arrow_back</span>
                    </button>
                    <h3>Kurum Kullanıcıları</h3>
                </div>
                <button className="btn-primary" onClick={() => setIsCreateModalOpen(true)}>
                    <span className="material-symbols-outlined">person_add</span>
                    Yeni Kullanıcı
                </button>
            </div>

            {isLoading && <div>Yükleniyor...</div>}

            <div className="users-table-container" style={{ background: 'white', borderRadius: '8px', border: '1px solid #e5e7eb', overflow: 'hidden' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                        <tr style={{ background: '#f9fafb', borderBottom: '1px solid #e5e7eb', textAlign: 'left' }}>
                            <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: 600, color: '#6b7280' }}>AD SOYAD</th>
                            <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: 600, color: '#6b7280' }}>E-POSTA</th>
                            <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: 600, color: '#6b7280' }}>ROL</th>
                            <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: 600, color: '#6b7280' }}>TARİH</th>
                            <th style={{ padding: '12px 16px', fontSize: '12px', fontWeight: 600, color: '#6b7280', textAlign: 'right' }}>İŞLEMLER</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user) => (
                            <tr key={user.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                                <td style={{ padding: '12px 16px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <div style={{ width: '32px', height: '32px', borderRadius: '50%', background: '#e0e7ff', color: '#4f46e5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '14px', fontWeight: 600 }}>
                                            {(user.full_name || user.email || '?')[0].toUpperCase()}
                                        </div>
                                        <span>{user.full_name}</span>
                                    </div>
                                </td>
                                <td style={{ padding: '12px 16px', color: '#4b5563' }}>{user.email}</td>
                                <td style={{ padding: '12px 16px' }}>
                                    <span style={{
                                        padding: '2px 8px', borderRadius: '4px', fontSize: '12px', fontWeight: 500,
                                        background: user.role === 'admin' ? '#fee2e2' : user.role === 'mudur' ? '#fef3c7' : '#e0e7ff',
                                        color: user.role === 'admin' ? '#991b1b' : user.role === 'mudur' ? '#92400e' : '#3730a3'
                                    }}>
                                        {user.role}
                                    </span>
                                </td>
                                <td style={{ padding: '12px 16px', color: '#6b7280', fontSize: '14px' }}>
                                    {new Date(user.created_at).toLocaleDateString('tr-TR')}
                                </td>
                                <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                                    <button
                                        onClick={() => setSelectedUserForReports(user.id)}
                                        className="btn-icon view-reports-btn"
                                        style={{
                                            background: '#e0e7ff',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            padding: '6px',
                                            color: '#3730a3',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginRight: '8px'
                                        }}
                                        title="Raporları Gör"
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>description</span>
                                    </button>
                                    <button
                                        onClick={() => handleDeleteUser(user.id, user.full_name)}
                                        className="btn-icon delete-btn"
                                        style={{
                                            background: '#fee2e2',
                                            border: 'none',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            padding: '6px',
                                            color: '#ef4444',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}
                                        title="Kullanıcıyı Sil"
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: '18px' }}>delete</span>
                                    </button>
                                </td>
                            </tr>
                        ))}
                        {users.length === 0 && !isLoading && (
                            <tr>
                                <td colSpan={4} style={{ padding: '24px', textAlign: 'center', color: '#6b7280' }}>
                                    Bu kuruma ait kullanıcı bulunamadı.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {isCreateModalOpen && (
                <CreateUserModal
                    institutionId={institutionId}
                    onClose={() => {
                        setIsCreateModalOpen(false);
                        fetchUsers();
                    }}
                />
            )}
        </div>
    );
};
